<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Descripcion</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="description"
                        class="form-control"
                        placeholder="nombre"
                    />
                    <span
                        v-if="allerrors.description"
                        :class="['show-error']"
                        >{{ allerrors.description[0] }}</span
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Regla</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="rule"
                        class="form-control"
                        placeholder="regla"
                    />
                    <span
                        v-if="allerrors.rule"
                        :class="['show-error']"
                        >{{ allerrors.rule[0] }}</span
                    >
                </div>
            </div>
            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            action: "",
            description: null,
            rule: null,
            allerrors: {
                description: null,
                rule: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/project-phase/show/" + me.model_id)
                .then(function (response) {
                    me.description = response.data.description;
                    me.rule = response.data.rule;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        description: me.description,
                        rule: me.rule,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        description: me.description,
                        rule: me.rule,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.description) {
                me.allerrors.description = [
                    "El campo descripcion es obligatorio.",
                ];
                valid = false;
            }

            if (!me.rule) {
                me.allerrors.rule = [
                    "El campo rule es obligatorio.",
                ];
                valid = false;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                description: null,
                rule: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector('meta[name="x-user"]').content;
        if (me.model_id == 0) {
            me.action = `/api/project-phase?key=${authUserId}`;
        } else {
            this.getModel();
            me.action = "/api/project-phase/update/" + me.model_id;
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
